import { focus, tabIndex } from 'utils/body-wrapper';

export function focusTop() {
  // Need to set tabIndex to -1 to make body focusable, as it is when the
  // browser first loads the page. Setting 0 introduces an extra tabstop.
  tabIndex(-1);
  focus();
}
